export * from './safe-html.component';
